import { deeplinkNavigation } from './DeeplinkNavigationParams'

export const navigationCreateTransaction = () => {
  deeplinkNavigation({
    name: 'CreateTransactionDetail',
  })
}
